import React, {useState} from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Select,
    MenuItem,
    FormControl,
    Typography,
    Box,
} from '@mui/material';

type FeedbackModalProps = {
    open: boolean;
    onClose: () => void;
    onSubmit: (category: string | null, description: string | null) => void;
};

const feedbackCategories = [
    'Not grounded in my data',
    'Incorrect or incomplete',
    'Misunderstood my request',
    'Output or system issue',
    'Other',
];

export const FeedbackModal: React.FC<FeedbackModalProps> = ({open, onClose, onSubmit}) => {
    const [category, setCategory] = useState<string>('');
    const [description, setDescription] = useState<string>('');

    const handleSubmit = () => {
        onSubmit(
            category || null,
            description || null
        );
        handleClose();
    };

    const handleClose = () => {
        setCategory('');
        setDescription('');
        onClose();
    };

    return (
        <Dialog 
            open={open} 
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                <Typography variant="h6" sx={{fontWeight: 700}}>
                    What went wrong?
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, mt: 1}}>
                    <Box>
                        <Typography variant="body2" sx={{mb: 1}}>
                            What type of issue do you wish to report (Optional)
                        </Typography>
                        <FormControl fullWidth>
                            <Select
                                value={category}
                                onChange={(e) => setCategory(e.target.value)}
                                displayEmpty
                                size="small"
                            >
                                <MenuItem value="">
                                    <em>Select an option</em>
                                </MenuItem>
                                {feedbackCategories.map((cat) => (
                                    <MenuItem key={cat} value={cat}>
                                        {cat}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                    <Box>
                        <Typography variant="body2" sx={{mb: 1}}>
                            Please provide details: (Optional)
                        </Typography>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            placeholder="What didn't meet your expectations?"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            size="small"
                        />
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions sx={{px: 3, pb: 2}}>
                <Button onClick={handleClose} variant="outlined">
                    Cancel
                </Button>
                <Button onClick={handleSubmit} variant="contained">
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};
